module.exports = __webpack_public_path__ + "f368af58763888283641b8ebf0f71bef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-soccer.png
// module id = 2814
// module chunks = 0